import { IGlobalSpinProp, InitGlobalSpin } from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IGlobalSpinProp = InitGlobalSpin;

export const spinSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setGlobalSpin: (state, action: PayloadAction<IGlobalSpinProp>) => {
      state = action.payload;
      return state;
    },
  },
});

const { actions, reducer } = spinSlice;
export const { setGlobalSpin } = actions;
export default reducer;
